// Generate gradient colors from username
const hashString = (str: string): number => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash = hash & hash // Convert to 32bit integer
  }
  return Math.abs(hash)
}

const generateColor = (seed: number, offset: number = 0): string => {
  const hue = (seed + offset) % 360
  const saturation = 60 + (seed % 20) // 60-80%
  const lightness = 45 + (seed % 15) // 45-60%
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`
}

export const generateGradientFromUsername = (username: string): string => {
  const hash = hashString(username.toLowerCase())
  const color1 = generateColor(hash, 0)
  const color2 = generateColor(hash, 120)
  const color3 = generateColor(hash, 240)
  
  return `linear-gradient(135deg, ${color1} 0%, ${color2} 50%, ${color3} 100%)`
}

export const generateProfilePictureSVG = (username: string, size: number = 100): string => {
  // Sanitize username to prevent XSS - only allow alphanumeric, underscore, hyphen
  const sanitizedUsername = username.replace(/[^a-zA-Z0-9_-]/g, '').toLowerCase() || 'u'
  const initial = sanitizedUsername.charAt(0)
  const hash = hashString(sanitizedUsername)
  
  // Generate futuristic colors with more vibrant hues
  const color1 = generateColor(hash, 0)
  const color2 = generateColor(hash, 120)
  const color3 = generateColor(hash, 240)
  
  return `
    <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="grad-${hash}" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:${color1};stop-opacity:1" />
          <stop offset="50%" style="stop-color:${color2};stop-opacity:1" />
          <stop offset="100%" style="stop-color:${color3};stop-opacity:1" />
        </linearGradient>
        <radialGradient id="glow-${hash}" cx="50%" cy="50%">
          <stop offset="0%" style="stop-color:rgba(255,255,255,0.3);stop-opacity:1" />
          <stop offset="100%" style="stop-color:rgba(255,255,255,0);stop-opacity:0" />
        </radialGradient>
        <style>
          @keyframes gradient-shift {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          @keyframes orb-float {
            0%, 100% { transform: translate(0, 0) scale(1) rotate(0deg); }
            33% { transform: translate(6px, -6px) scale(1.03) rotate(120deg); }
            66% { transform: translate(-4px, 4px) scale(0.97) rotate(240deg); }
          }
          @keyframes pulse {
            0%, 100% { opacity: 0.4; transform: scale(1); }
            50% { opacity: 0.6; transform: scale(1.05); }
          }
          .orb {
            animation: orb-float 8s cubic-bezier(0.4, 0, 0.6, 1) infinite;
            transform-origin: center;
          }
          .glow {
            animation: pulse 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
          }
        </style>
      </defs>
      <circle cx="${size/2}" cy="${size/2}" r="${size/2}" fill="url(#grad-${hash})" class="orb" />
      <circle cx="${size/2}" cy="${size/2}" r="${size/2 * 0.7}" fill="url(#glow-${hash})" class="glow" />
      <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-family="'Space Grotesk', -apple-system, sans-serif" font-size="${size * 0.45}" font-weight="600" fill="rgba(255, 255, 255, 0.95)" letter-spacing="-2px">${initial}</text>
    </svg>
  `
}

